module.exports = __webpack_public_path__ + "static/assets/e27dcf02542439089ddd83cfb1c3dadb.svg";